import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ExpandedHeatmapModalPage } from './expanded-heatmap-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ExpandedHeatmapModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ExpandedHeatmapModalPage]
})
export class ExpandedHeatmapModalPageModule {}
